import { useTranslation } from "react-i18next";
import {
  Box as MuiBox,
  Drawer as MuiDrawer,
  IconButton as MuiIconButton,
  Typography as MuiTypography,
} from "@mui/material";
import {
  ChevronLeft as MuiChevronLeftIcon,
  ChevronRight as MuiChevronRightIcon,
} from "@mui/icons-material";
import { Theme } from "common";

export const FilterPanel = (props) => {
  const { open, handleDrawerToggle } = props;
  const { t } = useTranslation();

  return (
    <MuiBox
      id="filterPanel"
      sx={{
        height: "100%",
        width: open ? "300px" : "32px",
        display: "flex",
        flexDirection: "column",
        borderRight: "1px solid",
        borderRightColor: Theme.palette.grey[400],
      }}
    >
      <MuiIconButton
        id="openDrawerButton"
        onClick={handleDrawerToggle}
        edge="start"
        size="small"
        sx={{
          display: open ? "none" : "block",
          marginTop: "24px",
        }}
      >
        <MuiChevronRightIcon fontSize="small" />
      </MuiIconButton>
      <MuiDrawer
        id="filterPanelDrawer"
        transitionDuration={0}
        variant="persistent"
        open={open}
        anchor="left"
        sx={{
          width: "100%",
          "& .MuiDrawer-paper": {
            width: "100%",
            zIndex: 0,
            position: "relative",
            border: "none",
          },
          "& .MuiTypography-root": { color: "text.primary" },
          "& .MuiGrid-root": { justifyContent: "space-around" },
        }}
      >
        <MuiBox
          id="filterPanelContent"
          sx={{
            padding: "24px 24px 0px 0px",
            display: "grid",
            rowGap: "25px",
            width: "100%",
          }}
        >
          <MuiBox
            id="toolbar"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <MuiTypography variant="h6">
              {t("FLA.filterPanel.title")}
            </MuiTypography>
            <MuiIconButton onClick={handleDrawerToggle} sx={{ margin: 0 }}>
              <MuiChevronLeftIcon fontSize="small" />
            </MuiIconButton>
          </MuiBox>
          {props.children}
        </MuiBox>
      </MuiDrawer>
    </MuiBox>
  );
};
